<template>
  <section class="section page__content">
    <div class="page__row mb-40" v-if="roleAccessEdit" style="justify-content: flex-end;">
      <AppButtonSmAdd title="Создать"
                      class="mr-20"
                      @click.stop.native="showComingTypeModal(null)"
      />

      <transition name="fade">
        <AppButtonSmRemove title="Удалить"
                           v-show="isActiveDelete"
                           @click.stop.native="showConfirmationModal"
        />
      </transition>
    </div>

    <AppTable v-if="comingTypesTable.length > 0"
              :data="comingTypesTable"
              :headers="comingTypesTableHeaders.header"
              :has-checkbox="roleAccessEdit"
              :isMenuControlsActive=false
              :all-items-active="comingTypesTableHeaders.allActive"
              @toggle-active-item="toggleActiveItem"
              @toggle-active-all="toggleActiveAll"
              @edit-this-item="showComingTypeModal"
              @show-this-item="showComingTypeModal"
    />

    <div class="page__row mb-20" v-else>
      <div class="no-records page__no-records">
        <AppNoRecordsPlaceholder text="Записи не найдены" />
      </div>
    </div>

    <transition name="fade" v-if="roleAccessEdit">
      <PvhOrderUpdateComingModal v-show="comingTypeModal.active"
                               @close-modal="closeComingTypeModal"
      >
        <template>
          <div class="page__item mb-30">
            <AppSelect title="Тип прихода"
                       :options="comingTypes"
                       :value="{name: comingTypeModal.select.name, id: comingTypeModal.select.id}"
                       openDirection="bottom"
                       @value-changed="setComingType"

            />
          </div>
            <div class="page__item mb-40">
            <AppInput title="Сумма"
                      required
                      :valid="comingTypeModal.validation.value"
                      :value="comingTypeModal.value"
                      @value-changed="setComingTypeValue"
                      @got-focus="clearValidation('valueComing')"
            />
          </div>

          <div class="modal__button-wrap">
            <div class="modal__button">
              <AppButton :title="comingTypeModal.updatedId == null ? 'Создать' : 'Сохранить' " type="main" @click.native="saveComingTypeModal"/>
            </div>
            <div class="modal__button" >
              <AppButton title="Отмена" type="alt" @click.native="closeComingTypeModal"/>
            </div>
          </div>

        </template>
      </PvhOrderUpdateComingModal>
    </transition>
    <transition name="fade" v-if="roleAccessEdit">
      <AppConfirmation
        v-if="removeConfirmation.isActive"
        text="Вы действительно хотите удалить эти приходы?"
        @confirm="deleteItem()"
        @reject="closeRemoveConfirmation()"
      />
    </transition>
  </section>
</template>

<script>
import AppTable from '@/components/page/table/AppTable'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import PvhOrderUpdateComingModal from '@/components/pvh/PvhOrderUpdateComingModal'
import AppSelect from '@/components/page/input/AppSelect'
import AppInput from '@/components/page/input/AppInput'
import AppButton from '@/components/page/button/AppButton'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
export default {
  name: 'PvhOrderUpdateComing',
  components: {
    AppConfirmation,
    AppButton,
    AppInput,
    AppSelect,
    PvhOrderUpdateComingModal,
    AppButtonSmRemove,
    AppButtonSmAdd,
    AppTable,
    AppNoRecordsPlaceholder
  },
  data () {
    return {
      removeConfirmation: {
        isActive: false
      }
    }
  },
  computed: {
    order () {
      return this.$store.getters['pvhOrderUpdatePage/[pvh] getOrderForUpdate']
    },
    comingTypes () {
      return this.$store.getters['pvhOrderUpdatePage/[pvh] getOrderUpdateComingTypes']
    },
    comingTypesTable () {
      return this.$store.getters['pvhOrderUpdatePage/[pvh] getOrderUpdateComingTypesTable'].map((type) => {
        return {
          isActive: type.isActive,
          id: type.id,
          values: [
            type.select.name,
            type.value
          ]
        }
      })
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    comingTypesTableHeaders () {
      return this.$store.getters['pvhOrderUpdatePage/[pvh] getOrderUpdateComingTypesTableHeaders']
    },
    comingTypeModal () {
      return this.$store.getters['pvhOrderUpdatePage/[pvh] getOrderUpdateComingTypeModal']
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightPvh.actions.update
    },
    isActiveDelete () {
      return this.$store.getters['pvhOrderUpdatePage/[pvh] getOrderUpdateComingTypeIsActiveDelete']
    }
  },
  methods: {
    showComingTypeModal (id) {
      return this.$store.commit('pvhOrderUpdatePage/[pvh] SHOW_ORDER_UPDATE_COMING_TYPE_MODAL', id)
    },
    closeComingTypeModal () {
      return this.$store.commit('pvhOrderUpdatePage/[pvh] CLOSE_ORDER_UPDATE_COMING_TYPE_MODAL')
    },
    setComingType (value) {
      return this.$store.commit('pvhOrderUpdatePage/[pvh] SET_ORDER_UPDATE_COMING_TYPE', value)
    },
    setComingTypeValue (value) {
      return this.$store.commit('pvhOrderUpdatePage/[pvh] SET_ORDER_UPDATE_COMING_TYPE_VALUE', value)
    },
    saveComingTypeModal () {
      return this.$store.commit('pvhOrderUpdatePage/[pvh] ADD_ORDER_UPDATE_COMING_TYPE')
    },
    clearValidation (value) {
      return this.$store.commit('pvhOrderUpdatePage/[pvh] ORDER_UPDATE_CLEAR_VALIDATION', value)
    },
    toggleActiveItem (itemId) {
      return this.$store.commit('pvhOrderUpdatePage/[pvh] TOGGLE_ORDER_UPDATE_COMING_TYPE_ACTIVE_ITEM', itemId)
    },
    toggleActiveAll () {
      return this.$store.commit('pvhOrderUpdatePage/[pvh] SET_ORDER_UPDATE_COMING_TYPE_ACTIVE_ALL')
    },
    deleteItem () {
      this.removeConfirmation.isActive = false
      return this.$store.commit('pvhOrderUpdatePage/[pvh] DELETE_ORDER_UPDATE_COMING_TYPE')
    },
    showConfirmationModal () {
      this.removeConfirmation.isActive = true
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.isActive = false
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.no-records {
  margin-top: 40px;
  align-items: center;
  width: 100%;
  display: flex;
}
.modal {
  max-width: 500px;
}
</style>
